export default __webpack_public_path__ + "static/media/things_todo_grey.7daada88.svg";